import { connect } from "react-redux"
import { Dispatch } from "redux"
import { ReduxAction } from "../../../../../../../../../reducers"
import { ContentActionDispatcher } from "../../../../../../../actiondispacher/content-action-dispacher"

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ContentActionDispatcher(dispatch),
})

export const container = connect(null, mapDispatchToProps)
